import type React from "react";
import { memo } from "react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { chartTypes, timeRanges, triggerClassName } from "../../../config";
import { type SectorsChartType, SectorsTimeRange } from "../../../types";

type Props = {
	chartType: SectorsChartType;
	handleValueChange: (value: SectorsChartType) => void;
	setTimeRange: (value: SectorsTimeRange) => void;
	timeRange: SectorsTimeRange;
	className?: string;
	otherProps?: Record<string, unknown>;
};

export const SectorsControls: React.FC<Props> = memo(({ ...props }) => {
	const {
		chartType,
		handleValueChange,
		setTimeRange,
		timeRange,
		...otherProps
	} = props;

	const filteredTimeRanges = timeRanges.filter(
		(range) => range !== SectorsTimeRange.FifteenDays || chartType === "Price", // we don't have 15D data for Ratio chart
	);

	return (
		<div className="control" {...otherProps}>
			<Select
				value={chartType}
				onValueChange={(v: SectorsChartType) => handleValueChange(v)}
			>
				<SelectTrigger className={triggerClassName}>
					<SelectValue>{chartType}</SelectValue>
				</SelectTrigger>

				<SelectContent>
					{chartTypes.map((type) => (
						<SelectItem key={type} value={type} className="cursor-pointer">
							{type}
						</SelectItem>
					))}
				</SelectContent>
			</Select>

			<Select
				value={timeRange}
				onValueChange={(v: SectorsTimeRange) => setTimeRange(v)}
			>
				<SelectTrigger className={triggerClassName}>
					<SelectValue>{timeRange}</SelectValue>
				</SelectTrigger>

				<SelectContent>
					{filteredTimeRanges.map((range) => (
						<SelectItem key={range} value={range} className="cursor-pointer">
							{range}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
});

SectorsControls.displayName = "SectorsControls";
